
/*----------------------
    BLOCKS INFO
---------------------- */
BlocksInfo = {
    init: function () {
        $(".bock-text__title").on("click", function () {
            if ($(window).width() > 641) {
                $("html, body").animate({ scrollTop: 0 }, 0);
            }
            $('.bock-text--info').scrollTop(0);

            $('.bock-text__title').not(this).removeClass('current');
            $(this).toggleClass("current");

            var block = $(this).data("block");
            $('.bock-text--info').not("#" + block).removeClass('open-block');
            $("#" + block).toggleClass("open-block");

            $(".bock-text__title-" + block).toggleClass("current");

            if ($(".bock-text--info").hasClass("open-block")) {
                $("body").addClass('open-block');

            } else {
                $("body").removeClass('open-block');
            }
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.bock-text__title, .bock-text--info').length) {
                $('.bock-text--info').removeClass('open-block');
                $('.bock-text__title').removeClass('current');
                if ($(".bock-text--info").hasClass("open-block")) {
                    $("body").addClass('open-block');
                } else {
                    $("body").removeClass('open-block');
                }
            }
        })

    }
};

/*----------------------
 STICKY
 ----------------------*/
Sticky = {
    init: function () {
        function sticky() {
            var height_menu = $(".header-menu__content").outerHeight();
            var height_div = $(".product__info").outerHeight() + height_menu;
            var height_window = $(window).height();

            if (height_div > height_window) {
                var result = height_div - height_window - height_menu;
                $(".product__info").css("top", -result);
            } else {
                $(".product__info").css("top", height_menu);
            }
        }
        sticky();

        $(window).on("resize", function () {
            sticky();
        });

        $("body").on("click", function (e) {
            setTimeout(function () {
                sticky();
            }, 1);
        })
    }
};


/*----------------------
    OPEN VARIATIONS
---------------------- */
openVariations = {
    init: function () {
        $(".attributes__title").on("click", function () {
            $(this).closest(".attributes-values").toggleClass("open");
        });
        $("body").on("click", function (e) {
            if (!$(e.target).closest('.attributes__title, .attributes-values').length) {
                $(".attributes-values").removeClass("open");

            }
        })
    }
};

/*----------------------
   SWIPER PRODUCT
---------------------- */
SwiperProduct = {
    init: function () {
        if ($(window).width() <= 640) {
            var swiper = new Swiper(".swiper-product-images", {
                navigation: {
                    nextEl: ".swiper-product-images-next",
                    prevEl: ".swiper-product-images-prev",
                },
            });

        }
        else {
            var swiper = new Swiper(".swiper-product-images", {
                direction: "vertical",
                slidesPerView: "auto",
                mousewheel: {
                    invert: false,
                    forceToAxis: true
                },
                freeMode: {
                    enabled: true,
                    sticky: false,
                    momentumBounce: false
                },
                scrollbar: {
                    el: ".swiper-scrollbar",
                    draggable: true,
    
                }
            });
        }
    }
};

$(document).ready(function () {
    BlocksInfo.init();
    openVariations.init();
    //Sticky.init();
    SwiperProduct.init();
});
$(document).on('shopify:section:load', function (event) {
    BlocksInfo.init();
    openVariations.init();
    //Sticky.init();
    SwiperProduct.init();
});
